import { render, staticRenderFns } from "./originalOrderDialog.vue?vue&type=template&id=a6d43d22&scoped=true"
import script from "./originalOrderDialog.vue?vue&type=script&lang=js"
export * from "./originalOrderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d43d22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6d43d22')) {
      api.createRecord('a6d43d22', component.options)
    } else {
      api.reload('a6d43d22', component.options)
    }
    module.hot.accept("./originalOrderDialog.vue?vue&type=template&id=a6d43d22&scoped=true", function () {
      api.rerender('a6d43d22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/projectSettlement/components/dialogs/originalOrderDialog.vue"
export default component.exports